import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "fw-semibold mb-8" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = {
  class: "col-12 col-sm-7 mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between",
  disabled: true
}
const _hoisted_6 = { class: "form-group col-6" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = { class: "form-group col-6" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "col-12 col-sm-5 mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between" }
const _hoisted_11 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Detail = _resolveComponent("Detail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, [
      _cache[6] || (_cache[6] = _createTextVNode(" Produkt: ", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.route.params.product), 1),
      _cache[7] || (_cache[7] = _createTextVNode(" , Evidence: ", -1)),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.route.params.evidence), 1)
    ]),
    _createElementVNode("span", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 text-muted" }, [
            _createElementVNode("i", { class: "flaticon-calendar lh-1 position-relative top-1" })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.borderDates.startDate) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setCustomDateSelection && _ctx.setCustomDateSelection(...args))),
            type: "date",
            class: "form-control shadow-none rounded-0 text-black me-1"
          }, null, 544), [
            [_vModelText, _ctx.borderDates.startDate]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 text-muted" }, [
            _createElementVNode("i", { class: "flaticon-calendar lh-1 position-relative top-1" })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.borderDates.endDate) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setCustomDateSelection && _ctx.setCustomDateSelection(...args))),
            type: "date",
            class: "form-control shadow-none rounded-0 text-black me-1"
          }, null, 544), [
            [_vModelText, _ctx.borderDates.endDate]
          ])
        ])
      ])
    ]),
    _createElementVNode("span", _hoisted_10, [
      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Časové období:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.timeSelected) = $event)),
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeBorderDates(_ctx.timeSelected))),
        class: "form-select shadow-none fw-semibold rounded-0 test"
      }, [...(_cache[10] || (_cache[10] = [
        _createStaticVNode("<option value=\"day\" data-v-75f866bb>Dnes</option><option value=\"week\" data-v-75f866bb>Týden</option><option value=\"month\" data-v-75f866bb>Měsíc</option><option value=\"30days\" data-v-75f866bb>30 dní</option><option value=\"60days\" data-v-75f866bb>60 dní</option><option value=\"90days\" data-v-75f866bb>90 dní</option><option value=\"120days\" data-v-75f866bb>120 dní</option><option value=\"custom\" data-v-75f866bb>Vlastní</option>", 8)
      ]))], 544), [
        [_vModelSelect, _ctx.timeSelected]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_Detail, {
        detailData: _ctx.detailData,
        borderDates: _ctx.borderDates
      }, null, 8, ["detailData", "borderDates"])
    ])
  ]))
}